import { render, staticRenderFns } from "./RequestInitialization.vue?vue&type=template&id=3f5d2200&scoped=true&"
import script from "./RequestInitialization.vue?vue&type=script&lang=js&"
export * from "./RequestInitialization.vue?vue&type=script&lang=js&"
import style0 from "./RequestInitialization.vue?vue&type=style&index=0&id=3f5d2200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5d2200",
  null
  
)

export default component.exports
import {QTable,QTr,QTh,QTd,QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign({QTable,QTr,QTh,QTd,QBtn,QTooltip}, component.options.components || {})
